export const TransferTypeMaxLength = {
  IMPS: 12,
  UPI: 12,
  NEFT: 16,
  RTGS: 22,
  "Internal ICICI": 12,
  "Internal SBIN": 10,
  Paytm: 19,
};

export const TransferTypeRegex: Record<string, RegExp> = {
  IMPS: /^[0-9]{12}$/,
  UPI: /^[0-9]{12}$/,
  NEFT: /^[a-zA-Z0-9]{16}$/,
  RTGS: /^[a-zA-Z0-9]{22}$/,
  "Internal ICICI": /^[0-9]{12}$/,
  "Internal SBIN": /^[a-zA-Z0-9]{10}$/,
  Paytm: /^[0-9]{18,19}$/,
};

export const TransferType = {
  IMPS: "IMPS",
};
